import { forwardRef } from "react";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { AlertLevel } from "../../components/AlertMessage";
import ModalAlert from "../../components/ModalAlert";
import { useRemoveGroupMutation } from "./peerReviewGroupsApiSlice";

interface RemovePeerReviewGroupButtonProps {
	onClick: () => void;
}

export const RemovePeerReviewGroupButton = forwardRef<
	HTMLButtonElement,
	RemovePeerReviewGroupButtonProps
>((props, ref) => {
	return (
		<button
			ref={ref}
			className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 "
			onClick={props.onClick}>
			<XCircleIcon className="size-4" />
			<span className="ml-2">Remove</span>
		</button>
	);
});

interface RemovePeerReviewGroupDialogProps {
	rowId: number | string;
	rowName: string;
	isDialogOpen: boolean;
	onRemoveCoursePromptGroup?: (uniqueId: string) => void;
	setAlert?: (message: string, level: AlertLevel) => void;
	onClose: () => void;
}

export function RemovePeerReviewGroupDialog(props: RemovePeerReviewGroupDialogProps) {
	const [removeGroup] = useRemoveGroupMutation();

	function handleRemoveGroup(id: number | string) {
		if (props.onRemoveCoursePromptGroup) {
			props.onRemoveCoursePromptGroup(id.toString());
		} else {
			removeGroup({ id: Number(id) })
				.unwrap()
				.then((message: string | undefined) => {
					props.setAlert?.(message ?? "", AlertLevel.Info) ?? console.log(message);
				})
				.catch((error: any) => {
					props.setAlert?.(error ?? "", AlertLevel.Error) ?? console.log(error);
					console.log(error);
				})
				.finally(() => props.onClose());
		}
	}

	return (
		<ModalAlert
			open={props.isDialogOpen}
			title={"Are You Sure?"}
			message={`Are you sure you want to remove “${props.rowName}”?`}
			type={AlertLevel.Warning}
			confirmLabel="Yes"
			cancelLabel="No"
			onConfirm={() => handleRemoveGroup(props.rowId)}
			onCancel={() => props.onClose()}
		/>
	);
}
